export default __webpack_public_path__ + "static/media/farm-MIVA-WXDAI.22d40a6c.svg";